/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

/*document.addEventListener('DOMContentLoaded', () => {
  const userLang = (navigator.language || navigator.userLanguage).toLowerCase();

  // Gestione delle lingue con solo il prefisso
  if (userLang.startsWith('de')) {
    window.location.href = "/de";
  } else if (!userLang.startsWith('it')) {
    window.location.href = "/en";
  }
});

document.addEventListener('DOMContentLoaded', () => {
const userLang = (navigator.language || navigator.userLanguage).toLowerCase();
const currentPath = window.location.pathname;

if (userLang.startsWith('de') && !currentPath.startsWith('/de')) {
  window.location.href = "/de";
} else if (!userLang.startsWith('it') && !currentPath.startsWith('/en')) {
  window.location.href = "/en";
}
});*/

document.addEventListener("DOMContentLoaded", function () {
  const headers = document.querySelectorAll(".accordion-header");

  headers.forEach((header) => {
    header.addEventListener("click", function () {
      const content = this.nextElementSibling;

      // Chiudi tutti gli altri accordion
      const allContents = document.querySelectorAll(".accordion-content");
      allContents.forEach((otherContent) => {
        if (otherContent !== content) {
          otherContent.classList.remove("active");
          otherContent.style.maxHeight = null;
        }
      });

      // Alterna lo stato attuale
      const isActive = content.classList.contains("active");
      content.classList.toggle("active", !isActive);
      content.style.maxHeight = isActive ? null : content.scrollHeight + "px";
    });
  });
});

document.querySelectorAll('.products-list__item__description p').forEach((element) => {
  // Rimuovi eventuali spazi iniziali e la prima parola (con i successivi spazi)
  element.textContent = element.textContent.replace(/^\s*\S+\s*/, '');
});
  
document.addEventListener('DOMContentLoaded', function() {
  // Trova tutte le categorie principali con sotto-menu
  const mainLinks = document.querySelectorAll('.mobile-navlink--level-1');

  mainLinks.forEach(function(link) {
    // Trova il relativo sotto-menu associato
    const dropdown = document.querySelector(`#MobileNav--${link.getAttribute('href').split('#')[1]}`);
    
    // Se il sotto-menu esiste, aprilo
    if (dropdown) {
      dropdown.classList.add('show');
    }
  });
});


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
